// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c28c2a6c","977":"c7d6623c"}[chunkId] + ".chunk.js";
};